/* eslint-disable import/prefer-default-export */
import type { IconProps } from './IconProps';

export const IconDefaults: IconProps = {
  size: 20,
  color: '#000000',
};
